import httpClient from "./httpClient";

const prefix = "/schoolings";

export async function getSchoolings() {
  return (await httpClient.get(prefix)).data;
}
